module.exports = __webpack_public_path__ + "resources/746554058e001fcffc5ab3f0212d47b9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/background-vp-negative.png
// module id = 194
// module chunks = 0